module.exports = __webpack_public_path__ + "img/maps-marker-nurtured.80d320e7.svg";